import { Box, Stack, Grid } from '@mui/material';
import type { FormikProps } from 'formik';

import InfoCard from '../../../components/info-card';
import { Payment } from '../../../components/bulk-request';
import { TestReview, AssessmentDetail, TotalSummary, TermsAndConditions } from '../../../components/shared';
import { type AddBulkRequestProps, Test } from '../../../models';
import { PaymentOptionSelector } from '../../../components/bulk-request';
import { PricingCalculator } from '../../../utils/pricingCalculator';

export const BulkRequestReview = ({ formik }: { formik: FormikProps<AddBulkRequestProps> }) => {
	const { tests, location, prefAssessmentDates } = formik.values;
	const pricedTests = tests.map((test) => ({
		...test,
		price: test.discountedPrice ?? test.price,
	}));

	const price = new PricingCalculator(pricedTests);

	const handlePaymentChange = (amount: number) => {
		if (formik.values.amount !== amount) {
			formik.setFieldValue('amount', amount);
		}
	};

	return (
		<Box>
			<Grid container spacing={3}>
				<Grid size={{ xs: 12, md: 7 }}>
					<Stack spacing={3}>
						<InfoCard title="Item Details">
							<TestReview tests={Test.removeNilTest(tests)} />
						</InfoCard>
						<InfoCard title="Assessment Details">
							<AssessmentDetail assessmentDates={prefAssessmentDates} location={location} dateLineText="Preferred" />
						</InfoCard>
						<Payment>
							<PaymentOptionSelector tests={pricedTests} onChange={handlePaymentChange} />
						</Payment>

						{formik && <TermsAndConditions formik={formik} />}
					</Stack>
				</Grid>

				<Grid size={{ xs: 12, md: 5 }}>
					<InfoCard title="Summary">
						<TotalSummary total={price.total()} subtotal={price.subtotal()} gst={price.gst()} />
					</InfoCard>
				</Grid>
			</Grid>
		</Box>
	);
};
